import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

export const documentTypeValidationSchema = yup.object().shape({
  documentType: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup.string().required(),
    })
    .required(() => (
      <FormattedMessage
        defaultMessage='Document type selection is required'
        id='sputnik.DocumentUploadTypeModal__59iqQS'
      />
    )),
})

export type DocumentTypeValidationSchema = yup.InferType<typeof documentTypeValidationSchema>
